export { CommunicationColors, NeutralColors, SharedColors } from '@fluentui/theme';
